import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { LanguageModel } from "@iatec/nephos-layout";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class HttpLanguageService {
    private http = inject(HttpClient);

    public getLanguages(): Observable<LanguageModel[]> {
        return this.http.get<LanguageModel[]>("./mock/languages.json");
    }
}
